import { Text } from '@digitools/honest-ui';
import React, { useContext } from 'react';
import { ExperienceContext } from '../../../../providers/ExperienceProvider';
import getDisplayText from '../../../../utils/languageDisplay';
import { MultiCustomerDisplayTextEn } from './i18n/MultiCustomerDisplayTextEn';
import { MultiCustomerDisplayTextEs } from './i18n/MultiCustomerDisplayTextEs';
/**
 * Shown when an authenticated user has no customers associated to them - vendors and
 * brokers awaiting book-of-business association, most commonly.
 */
const UnassociatedMessage = () => {
    const { language } = useContext(ExperienceContext);
    const getLocalDisplayText = (key) => getDisplayText.apply({}, [key, MultiCustomerDisplayTextEn, MultiCustomerDisplayTextEs, language]);
    return (<Text as={'div'} data-public={true} id={'nocustomer-message'} data-testid={'unitialized'}>
      {getLocalDisplayText('unassociatedMessage')}
    </Text>);
};
export default UnassociatedMessage;
